import { h, Component, Fragment } from 'preact';
import dayjs from 'lib/helpers/dayjs';
import Input from '../Input'
import style from './index.less'
import I18n from '../I18n'
import { times, uuid, formatPhoneNumber } from 'lib/helpers';
import { FAChevronLeft, FAChevronRight }  from '../FontAwesome';
import _ from 'lodash'

export default (Constructor)=>{

    return class _Form extends Component{
        constructor(props){
            super()
            this.state = {}
            this.id = uuid()
        }
        
        componentWillMount(){
            const component = this

            class ControlledInput extends Component {
                constructor(props){
                    super(props)
                    this.state = {
                        interacted: false,
                        value: component.state[props.name] || props.initialValue || ''
                    }

                    this.name = props.name
                    this.onChange = this.onChange.bind(this)
                    this.onBlur = this.onBlur.bind(this)
                }

                componentDidUpdate(){
                    if(component.state.__resetI && !this.state.__resetI){
                        this.setState({
                            ...JSON.parse(JSON.stringify(component.state))
                        })
                    }else if(component.state.__resetI){
                        if(component.state.__resetI > this.state.__resetI){
                            this.setState({
                                ...JSON.parse(JSON.stringify(component.state))
                            })
                        }
                    }
                }

                componentWillMount(){
                    if(this.state.value && !component.state[this.name]){
                        component.setState({
                            [this.name]: this.state.value
                        })
                    }
                }


                onChange(e){
                    e.preventDefault()
                    component.setState({
                        [this.name]: e.target.value
                    })
                    this.setState({
                        interacted: true,
                        value: e.target.value
                    })
                    this.props.onChange && this.props.onChange(e)
                }

                onBlur(e){
                    component.setState({
                        [this.name]: e.target.value
                    })
                    this.setState({
                        interacted: true,
                        value: e.target.value
                    })
                    this.props.onBlur && this.props.onBlur(e)
                }

                render(){
                    let name = `${this.props.question}`.replace(/\ /g, '')
                    name = `${name[0].toLowerCase()}${name.substring(1, name.length)}`
                    return (
                        <Input 
                            {...this.props}
                            interacted={this.state.interacted}
                            name={this.props.name || name}
                            placeholder={this.props.placeholder || this.props.question}
                            onChange={this.onChange}
                            onBlur={this.onBlur}
                            onClick={this.onClick} 
                            value={this.state.value}
                        />
                    )
                }
            }
        
            const ControlledInputDark = (props)=>{
                props.dark = true
                return (<ControlledInput {...props} />)
            }


            class ControlledMaskedInput extends Component {
                constructor(props){
                    super(props)
                    let initialValue = formatPhoneNumber(component.state[props.name] || props.initialValue || '')
                    this.state = {
                        interacted: false,
                        value: initialValue
                    }

                    this.name = props.name
                    this.onChange = this.onChange.bind(this)
                    this.onBlur = this.onBlur.bind(this)
                    this.process = this.process.bind(this)
                    this.handleValidation = this.handleValidation.bind(this)
                }

                componentWillMount(){
                    if(this.state.value && !component.state[this.name]){
                        component.setState({
                            [this.name]: this.state.value
                        })
                    }
                }

                onBlur(e){
                    component.setState({
                        [this.name]: e.target.value
                    })
                    this.setState({
                        interacted: true,
                        value: e.target.value
                    })
                    this.props.onBlur && this.props.onBlur(e)
                }

                process(value){
                    switch(this.props.type){
                        case 'tel':
                            value = value.replace(/\D/g, "")
                            value = value.split("")
                    
                            if(value.length > 3){
                                value.splice(3, 0, '-')
                            }
                    
                            if(value.length > 7){
                                value.splice(7, 0, '-')
                            }
                    
                            if(value.length < 13){
                                return value.join('')
                            }
                    }
                    return false
                }
                
                handleValidation(){
                    let value = this.state.value
            
                    if((this.props.types || []).includes('tel') && !value.match(/\D/g)){
                        let _value = formatPhoneNumber(value)
                        if(_value.length < 13){
                            this.setState({
                                value: _value.join('')
                            })
                            this.props.onChange && this.props.onChange(e)
                        }
                    }
                }

                onChange(e){
                    e.preventDefault()
                    let value = e.target.value
                    
                    if(this.process(value) !== false){
                        value = this.process(value)
                        
                        component.setState({
                            [this.name]: value
                        })
                        this.setState({
                            interacted: true,
                            value
                        })

                        this.props.onChange && this.props.onChange(e)
                    }else{
                        component.setState({
                            [this.name]: value
                        })
                        this.setState({
                            interacted: true,
                            value
                        })

                        this.props.onChange && this.props.onChange(e)
                    }
                }

                render(){
                    let name = `${this.props.question}`.replace(/\ /g, '')
                    name = `${name[0].toLowerCase()}${name.substring(1, name.length)}`
                    return (
                        <Input 
                            {...this.props}
                            interacted={this.state.interacted}
                            name={this.props.name || name}
                            placeholder={this.props.placeholder || this.props.question}
                            onChange={this.onChange}
                            onBlur={this.handleValidation}
                            onClick={this.onClick} 
                            value={this.state.value}
                        />
                    )
                }
            }
        
            const ControlledMaskedInputDark = (props)=>{
                props.dark = true
                return (<ControlledMaskedInput {...props} />)
            }

            class Select extends Component {
                constructor(props){
                    super()
                    this.state = {
                        display: 'none',
                        highlighted: '',
                        interacted: false,
                        search: undefined,
                        value: component.state[props.name] || props.initialValue || ''
                    }
                    this.handleFocus = this.handleFocus.bind(this)
                    this.handleLeave = this.handleLeave.bind(this)
                    this.onChange = this.onChange.bind(this)
                    this.handleSearch = this.handleSearch.bind(this)
                    this.handleSelect = this.handleSelect.bind(this)
                    this.getClass = this.getClass.bind(this)
                }
                componentWillMount(){
                    if(this.state.value && !component.state[this.name]){
                        component.setState({
                            [this.name]: this.state.value
                        })
                    }
                }
                onChange (row){
                    this.setState({
                        value: row.value,
                        display: 'none',
                        search: undefined
                    })

                    component.setState({
                        [this.name]: row.value
                    })
                    this.props.onChange && this.props.onChange(row.value)
                }
                handleFocus(e){
                    let search = ''
                    if(this.props.preventClearOnFocus){
                        search = this.state.search
                    }
                    this.setState({
                        display: 'block',
                        highlighted: '',
                        search
                    })
                }

                handleLeave(e){
                    this.setState({
                        display: 'none',
                        search: undefined,
                        interacted: true
                    })
                }

                get name(){
                    let name = `${this.props.question}`.replace(/\ /g, '')
                    name = `${name[0].toLowerCase()}${name.substring(1, name.length)}`
                    return this.props.name || name
                }

                handleSearch(e){
                    this.setState({
                        search: e.target.value,
                    })
                    this.props.onSearch && this.props.onSearch(e.target.value)
                }
                get data(){
                    let search = this.state.search || ''
                    let dropDownLimit = this.props.dropDownLength || this.props.data.length

                    const _data = (this.props.data || []).filter((item)=>(
                        `${item.name}`.toLowerCase().includes(search.toLowerCase())
                    )).slice(0, dropDownLimit)
                    
                    const orderedData = _.orderBy(_data, [(i) =>{
                        let item = i.name.toLowerCase().split(" ")[0]
                        let intItem = parseInt(item)
                        if(!_.isNaN(intItem)) return intItem
                        return item 
                    }], ['asc'])
                    return orderedData
                }
                handleSelect(e){
                    if(e.keyCode == 13){
                        //ENTER
                        e.preventDefault()
                        if(this.data[0]){
                            this.onChange(
                                this.data.find((d)=>
                                    d.value == this.state.highlighted
                                ) || this.data[0]
                            )

                            e.target.blur()
                        }
                    }else if(e.keyCode == 9){
                        //TAB
                        e.preventDefault()

                        if(this.data[0]){
                            this.setState({
                                search: this.data[0].name
                            })
                        }
                    }else if(e.keyCode == 40){
                        //DOWN ARROW
                        let highlighted = this.state.highlighted
                        if(!highlighted){
                            highlighted = this.data[0].value
                        } else {
                            let i = this.data.map((d)=>d.value).indexOf(highlighted)
                            if(i < (this.data.length - 1)){
                                highlighted = this.data[i+1].value
                            } else {
                                highlighted = this.data[0].value
                            }
                        }

                        this.setState({
                            highlighted
                        })
                    }else if(e.keyCode == 38){
                        //UP ARROW
                        let highlighted = this.state.highlighted
                        if(!highlighted){
                            highlighted = this.data[this.data.length - 1].value
                        } else {
                            let i = this.data.map((d)=>d.value).indexOf(highlighted)
                            if(i > 0){
                                highlighted = this.data[i-1].value
                            } else {
                                highlighted = this.data[this.data.length - 1].value
                            }
                        }

                        this.setState({
                            highlighted
                        })
                    }
                }
                get currentInputValue(){
                    if(!_.isNil(this.state.search)) return this.state.search

                    let _item = _.find(this.props.data,(item)=>item.value == this.state.value)
                    if(_item) return _item.name
                    return ''
                }
                getClass(row){
                    let divStyle = style.option
                    if(this.state.highlighted == row.value){
                        divStyle += ` ${style.highlighted}`
                    }
                    return divStyle
                }
                render(){
                    const placeholder = this.props.placeholder || this.props.question
                    let inputClass = []
                    this.props.class && inputClass.push(this.props.class)
                    this.props.dark && inputClass.push(style.dark)
                    this.props.required && this.state.interacted && inputClass.push(style.required)
                    const optional = {}
                    
                    if(this.props.step) optional.step = this.props.step

                    return (
                        <div
                            placeholder={this.props.placeholder || this.props.question}
                            class={style.container}
                            >

                            <input
                                type='text'
                                required={this.props.required}
                                onChange={this.handleSearch}
                                onInput={this.handleSearch}
                                onLoad={this.handleSearch}
                                value={this.currentInputValue}
                                placeholder={placeholder}
                                onFocus={this.handleFocus}
                                onBlur={this.handleLeave}
                                onKeyDown={this.handleSelect}
                                class={inputClass.join(' ')}
                                autocomplete={this.props.autocomplete || 'true'}
                                {...optional}
                            />

                            <div class={style.options} style={{display: this.state.display }}>
                                {this.data.map((row)=>(
                                    <div onMouseDown={this.onChange.bind(null, row)} class={this.getClass(row)}>
                                        {row.name}
                                    </div>
                                ))}
                                {this.data.length < this.props.data.length && (
                                    <Fragment>
                                        <div class={[style.option, style.more].join(' ')}>
                                            ...
                                        </div>
                                        <div class={[style.option, style.more].join(' ')}>
                                            Search for more
                                        </div>
                                    </Fragment>
                                )}
                            </div>
                        </div>
                    )
                }
            }

            const SelectDark = (props)=>(
                <Select {...props} dark={true} />
            )

            class DatePicker extends Component {
                constructor(props){
                    super(props)
                    this.state = {
                        display: 'none',
                        displayDate: dayjs(),
                        interacted: false,
                        value: component.state[props.name] || dayjs(props.initialValue)
                    }

                    this.name = props.name
                    this.handleSearch = this.handleSearch.bind(this)
                    this.handleEnter = this.handleEnter.bind(this)
                    this.handleFocus = this.handleFocus.bind(this)
                    this.handleLeave = this.handleLeave.bind(this)
                    this.handleSelect = this.handleSelect.bind(this)
                    this.handlePrevMonth = this.handlePrevMonth.bind(this)
                    this.handleNextMonth = this.handleNextMonth.bind(this)
                    this.handlePrevYear = this.handlePrevYear.bind(this)
                    this.handleNextYear = this.handleNextYear.bind(this)
                    this.preventClose = this.preventClose.bind(this)
                }

                componentWillMount(){
                    if(this.state.value && !component.state[this.name]){
                        component.setState({
                            [this.name]: this.state.value
                        })
                    }
                }

                componentWillReceiveProps(newProps){
                    if(newProps.value && dayjs(newProps.value).format("MM/DD/YYYY") != this.state.value.format("MM/DD/YYYY")){
                        this.setState({
                            displayDate: dayjs(newProps.value)
                        })
                    }
                }

                handlePrevYear(e){
                    e.preventDefault()
                    this.setState({
                        displayDate: this.state.displayDate.subtract(1, 'year')
                    })
                }

                handleNextYear(e){
                    e.preventDefault()
                    this.setState({
                        displayDate: this.state.displayDate.add(1, 'year')
                    })
                }
                
                
                handlePrevMonth(e){
                    e.preventDefault()
                    this.setState({
                        displayDate: this.state.displayDate.subtract(1, 'month')
                    })
                }

                handleNextMonth(e){
                    e.preventDefault()
                    this.setState({
                        displayDate: this.state.displayDate.add(1, 'month')
                    })
                }
                
                handleFocus(e){
                    let search = ''
                    if(this.props.preventClearOnFocus){
                        search = this.state.search
                    }
                    
                    this.setState({
                        display: 'block',
                        search
                    })
                }

                handleLeave(e){
                    this.setState({
                        display: 'none',
                        search: undefined,
                        interacted: true
                    })
                }

                handleEnter(e){
                    if(e.keyCode == 13){
                        //ENTER
                        e.preventDefault()
                        if(this.state.search){
                            let _date = dayjs(this.state.search)
                            if(_date.isValid()){
                                this.setState({
                                    value: _date,
                                    display: 'none',
                                    search: undefined
                                })
                                component.setState({
                                    [this.name]: _date
                                })
                            }
                        }
                    }
                }

                handleSelect(date,e){
                    e.preventDefault()

                    if(this.props.min && dayjs(date).endOf('day').isBefore(dayjs(this.props.min).startOf('day'))){
                        return
                    }
                    if(this.props.max && dayjs(date).startOf('day').isAfter(dayjs(this.props.max).endOf('day'))){
                        return
                    }
                    
                    this.setState({
                        value: date,
                        display: 'none',
                        search: undefined
                    })
                    component.setState({
                        [this.name]: date
                    })

                    this.props.onChange && this.props.onChange(date)
                }

                handleSearch(e){
                    let _date = dayjs(e.target.value)
                    if(_date.isValid()){
                        this.setState({
                            displayDate: _date,
                        })
                    }
                    this.setState({
                        search: e.target.value,
                    })
                    this.props.onSearch && this.props.onSearch(e.target.value)
                }

                get currentInputValue(){
                    if(typeof this.state.search == 'string'){
                        return this.state.search
                    } 

                    if(this.state.value.format){
                        return this.state.value.format('MM/DD/YYYY')
                    }
                }

                preventClose(e){
                    e.preventDefault()
                }
                
                render(){
                    //NO LONGER USED, NOT RENDERED
                    const placeholder = this.props.placeholder || this.props.question
                    let inputClass = []
                    this.props.class && inputClass.push(this.props.class)
                    this.props.dark && inputClass.push(style.dark)
                    this.props.required && this.state.interacted && inputClass.push(style.required)

                    let monthStart = this.state.displayDate.clone().startOf('month')
                    let monthEnd = this.state.displayDate.clone().endOf('month')

                    let daysToGenerate = monthEnd.date() + monthStart.day()
                    return (
                        <div
                            placeholder={this.props.placeholder || this.props.question}
                            class={[style.container, style.datePicker].join(' ')}
                            >

                            <input
                                type='text'
                                required={this.props.required}
                                value={this.currentInputValue}
                                placeholder={placeholder}
                                onFocus={this.handleFocus}
                                onChange={this.handleSearch}
                                onKeyDown={this.handleEnter}
                                onBlur={this.handleLeave}
                                onMouseDown={this.handleFocus}
                                class={inputClass.join(' ')}
                            />

                            <div class={style.options} style={{display: this.state.display }}>
                                <div class={style.calendar} onMouseDown={this.preventClose}>
                                    <span onMouseDown={this.handlePrevYear} class={style.leftChevron}>
                                        <FAChevronLeft />
                                    </span>
                                    <div class={style.monthContainer}>{this.state.displayDate.format("YYYY").toLowerCase()}</div>
                                    <span onMouseDown={this.handleNextYear} class={style.rightChevron}>
                                        <FAChevronRight />
                                    </span>
                                    <br />
                                    {/* <!-- \/ Ashley --> */}
                                    <span onClick={this.handlePrevMonth} class={style.leftChevron}>
                                        <FAChevronLeft />
                                    </span>
                                    <div class={style.monthContainer}><I18n>{this.state.displayDate.format("MMMM").toLowerCase()}</I18n></div>
                                    <span onClick={this.handleNextMonth} class={style.rightChevron}>
                                        <FAChevronRight />
                                    </span>
                                    <div>
                                        <table>
                                            <tr>
                                                <th><I18n>S</I18n></th>
                                                <th><I18n>M</I18n></th>
                                                <th><I18n>T</I18n></th>
                                                <th><I18n>W</I18n></th>
                                                <th><I18n>T</I18n></th>
                                                <th><I18n>F</I18n></th>
                                                <th><I18n>S</I18n></th>
                                            </tr>
                                            {times(daysToGenerate / 7).map((i)=>{
                                                return (
                                                    <tr>
                                                        {times(7).map((j)=>{
                                                            let $date = ((i*7) + (j+1)) - monthStart.day()
                                                            if($date <= 0 || $date > monthEnd.date()){
                                                                return <td></td>
                                                            }
                                                            let date = monthStart.clone().set('date',$date)
                                                            let dateClass = []
                                                            let type = style.day;
                                                            if(this.props.min){
                                                                if(dayjs(date).endOf('day').isBefore(dayjs(this.props.min).startOf('day'))){
                                                                    type = style.pastDay // IS BEFORE MIN DATE
                                                                }
                                                            }
                                                            if(this.props.max){

                                                                if(dayjs(date).startOf('day').isAfter(dayjs(this.props.max).endOf('day'))){
                                                                    type = style.pastDay // IS AFTER MAX DATE
                                                                }
                                                            } 
                                                            dateClass.push(type)
                                                            return <td class={dateClass.join(' ')} onMouseDown={this.handleSelect.bind(null,date)}>{$date}</td>
                                                        })}
                                                    </tr>
                                                )
                                            })}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            }

            const DatePickerDark = (props)=>(
                <DatePicker {...props} dark={true} />
            )

            class Form extends Component {
                constructor(){
                    super()
                    this.state = {
                        error: false
                    }
                    this.onSubmit = this.onSubmit.bind(this)
                }

                onSubmit(e){
                    e.preventDefault()
                    this.setState({
                        error: false
                    })


                    const params = _.omit(component.state, '__resetI')
                    this.props.onSubmit && this.props.onSubmit({...params})
                }
                render(){
                    const _class = [style.form]
                    this.props.class && _class.push(this.props.class)
                    this.state.error && _class.push(style.error)
                    return (
                        <form onSubmit={this.onSubmit} class={_class.join(' ')}>
                            {this.props.children}
                        </form>
                    )
                }
            }
            Form.reset = ()=>{
                const resetI = component.state.__resetI || 0
                const resetData = {}
                for(let key of Object.keys(component.state)){
                    resetData[key] = undefined
                }
                component.setState({
                    ...resetData,
                    resetI: resetI + 1
                })
            }
            this.ControlledInput = ControlledInput
            this.ControlledInputDark = ControlledInputDark
            this.ControlledMaskedInput = ControlledMaskedInput
            this.ControlledMaskedInputDark = ControlledMaskedInputDark
            this.Form = Form
            this.Select = Select
            this.SelectDark = SelectDark
            this.DatePicker = DatePicker
            this.DatePickerDark = DatePickerDark
            this.FormData = this.state
        }

        render(){
            return <Constructor
                {...this.props}
                formState={this.state}
                Input={this.ControlledInput}
                InputDark={this.ControlledInputDark}
                MaskedInput={this.ControlledMaskedInput}
                MaskedInputDark={this.ControlledMaskedInputDark}
                Form={this.Form}
                Select={this.Select}
                SelectDark={this.SelectDark}
                DatePicker={this.DatePicker}
                DatePickerDark={this.DatePickerDark}
                FormData={this.state}
                value={this.state.value}
                onChange={this.handleChange}
                onBlur={this.handleValidation}
                ref={(a)=>{ this.inputElement = a}}
            />
        }
    }
}



// WEBPACK FOOTER //
// ./components/elements/Form/index.js